import gql from 'graphql-tag';

export const UPDATE_PO_UPLOADED = gql`
  mutation updatePOUploaded(
    $caseId: String
    $caseExternalId: String
    $isPOUploaded: Boolean!
    $poAttachmentTimestamp: String
  ) {
    updatePOUploaded(
      caseId: $caseId
      caseExternalId: $caseExternalId
      isPOUploaded: $isPOUploaded
      poAttachmentTimestamp: $poAttachmentTimestamp
    ) {
      success
      message
    }
  }
`;